import { render, staticRenderFns } from "./ButtonCreateGroup.vue?vue&type=template&id=72f846a3&"
import script from "./ButtonCreateGroup.vue?vue&type=script&lang=ts&"
export * from "./ButtonCreateGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports